import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid } from '@mui/material';
import { textOverflowMui } from 'constants/textOverflowMui';

import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';

import { concatWithDot } from 'helpers/string';

import { ITableRowProps } from '../ForecastedConsumption/ForcastedConsumptionDataTable/types';

const defaultGetRowName = (name: string, columnName: string, rowIndex?: number) => {
  return concatWithDot(name, rowIndex?.toString() || '', columnName);
};

export const TableRow: FC<ITableRowProps> = ({
  name,
  rowIndex,
  columnsNames,
  disabled = false,
  getRowName = defaultGetRowName,
  handleRemove,
  firstColumnMaxLength,
  firstColumnWidth,
  lastColumnWidth,
  rowName = '',
  columnMultiline = true,
  canDeleteFirstRow = false,
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid
        container
        spacing={0}
        sx={{
          marginBottom: '12px',
          '& .MuiBox-root': {
            height: '100%',
          },
        }}
        wrap="nowrap"
      >
        <Grid item width={firstColumnWidth} height="100%" marginRight={1}>
          <TextInputControl
            control={control}
            id={rowName}
            name={rowName}
            disabled={disabled}
            placeholder=""
            hiddenLabel
            maxLength={firstColumnMaxLength}
            sx={{
              '&.MuiFormControl-root': {
                height: '40px',
                maxWidth: '140px',
              },
              '& .MuiOutlinedInput-input': {
                padding: '10px',
              },
            }}
            InputProps={{
              sx: {
                height: '100%',
                minHeight: '100%',
                alignItems: 'stretch',
                display: 'flex',
              },
            }}
          />
        </Grid>
        <Grid item xs container paddingLeft={0}>
          <Grid container spacing={1} columns={columnsNames.length} wrap="nowrap" flexGrow="1">
            {columnsNames.map((columnName) => {
              const fieldName = getRowName(name, columnName, rowIndex);
              return (
                <Grid key={columnName} item xs={1}>
                  <NumberInputControlled
                    control={control}
                    id={fieldName}
                    name={fieldName}
                    disabled={disabled}
                    hiddenLabel
                    placeholder=""
                    multiline={columnMultiline}
                    sx={{
                      '&.MuiFormControl-root ': {
                        height: '100%',
                      },
                    }}
                    InputProps={{
                      sx: {
                        height: '100%',
                        minHeight: '100%',
                        alignItems: 'stretch',
                        display: 'flex',
                      },
                    }}
                    inputProps={{
                      sx: textOverflowMui,
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        <Grid item width={lastColumnWidth}>
          {handleRemove && (
            <RemoveButton
              canRemove={rowIndex !== 0 || canDeleteFirstRow}
              disabled={disabled}
              onClick={rowIndex || canDeleteFirstRow ? () => handleRemove(rowIndex) : undefined}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};
